import { render, staticRenderFns } from "./NotificationObject.vue?vue&type=template&id=432212cc&scoped=true&"
import script from "./NotificationObject.vue?vue&type=script&lang=js&"
export * from "./NotificationObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432212cc",
  null
  
)

export default component.exports